import { render } from "./ResendToRxnt.vue?vue&type=template&id=032a6008&scoped=true"
import script from "./ResendToRxnt.vue?vue&type=script&lang=js"
export * from "./ResendToRxnt.vue?vue&type=script&lang=js"

import "./ResendToRxnt.vue?vue&type=style&index=0&id=032a6008&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-032a6008"],['__file',"src/views/ResendToRxnt.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "032a6008"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('032a6008', __exports__)) {
    console.log('reload')
    api.reload('032a6008', __exports__)
  }
  
  module.hot.accept("./ResendToRxnt.vue?vue&type=template&id=032a6008&scoped=true", () => {
    console.log('re-render')
    api.rerender('032a6008', render)
  })

}


export default __exports__